import { atom } from 'recoil';
import { Coupon } from '~/types';

const couponList = atom<Array<Coupon>>({
  key: 'couponList',
  default: [],
});

export default couponList;
